export class FmkSignInController {

    /* @ngInject */
    constructor(userSessionService) {
        this.userSessionService = userSessionService;
    }

    $onInit() {
        this.userSessionService.getUserSession()
            .then(session => {
                this.stsIdCardException = session.stsIdCardException;
            })
            .catch(error => this.$log.error(error));
    }

}